import type { PdfRepositionableField } from '@urbanx/agx.ui-components2';
import { nswContractExchangeDocuSignAnchors } from './contractExchangeDocuSignAnchors';

const textFields: PdfRepositionableField[] = [
  { name: 'Buyer1Name' },
  { name: 'Buyer1Address' },
  { name: 'Buyer2Name' },
  { name: 'Buyer2Address' },
  { name: 'Buyer3Name' },
  { name: 'Buyer3Address' },
  { name: 'Buyer4Name' },
  { name: 'Buyer4Address' },
  { name: 'PurchaserSolicitorName' },
  { name: 'PurchaserSolicitorAddress' },
  { name: 'PurchaserSolicitorPhone' },
  { name: 'PurchaserSolicitorEmail' },
  { name: 'Price' },
  { name: 'Deposit' },
  { name: 'Balance' },
  { name: 'BuyerAgentName' },
  { name: 'BuyerAgentAddress' },
  { name: 'BuyerAgentPhone' },
  { name: 'BuyerAgentEmail' },
  { name: 'Sellers5LegalName' },
  { name: 'Sellers6LegalName' },
  { name: 'Buyers5NameFullName' },
  { name: 'Buyers6NameFullName' },
];

export const contractExchangeRepositionFields: PdfRepositionableField[] = [
  ...textFields,
  {
    name: 'ContractDateAnchor',
    anchorText: 'NSWCECONTRACTDATEPOSITION',
    pageIndex: 0,
    placeholder: { text: 'Contract date', width: 200, height: 14.31 },
  },
  ...Array.from({ length: 6 }, (_, i) => [
    {
      name: `Sellers${i + 1}SignatureSignHere`,
      anchorText: nswContractExchangeDocuSignAnchors.sellerSignature(i + 1),
    },
    {
      name: `Sellers${i + 1}InitialHere`,
      anchorText: nswContractExchangeDocuSignAnchors.sellerInitial(i + 1),
    },
  ]).flat(),
  ...Array.from({ length: 6 }, (_, i) => [
    {
      name: `Buyers${i + 1}SignatureSignHere`,
      anchorText: nswContractExchangeDocuSignAnchors.buyerSignature(i + 1),
    },
    {
      name: `Buyers${i + 1}InitialHere`,
      anchorText: nswContractExchangeDocuSignAnchors.buyerInitial(i + 1),
    },
  ]).flat(),
];
